// Paket 08 Schritt 7 (EIN-10): Hell, Dunkel oder System. Das einzige Modul, das die Wahl `theme` im Browserspeicher liest
// und schreibt; das Startskript in index.html setzt die Klasse dark vor dem ersten Rendern nach derselben Regel. Ohne oder
// mit ungültiger Wahl gilt Hell; ein gesperrter Speicher ist kein Fehler (12-A). Profil-Nachbau F-09 (BAU-PRAEFERENZEN.md
// 1.2): die Wahl gilt am Konto auf allen Geräten; der Browserspeicher hält eine Kopie, damit das Startskript ohne Aufblitzen färbt.
export type ThemeChoice = 'light' | 'dark' | 'system';
export const THEME_KEY = 'theme';
export const THEME_EVENT = 'theme:changed';
const WAHLEN: readonly ThemeChoice[] = ['light', 'dark', 'system'];
const SYSTEM_DUNKEL = '(prefers-color-scheme: dark)';
type Wurzel = { classList: { toggle(name: string, force?: boolean): unknown } };
type Medium = Pick<MediaQueryList, 'matches' | 'addEventListener' | 'removeEventListener'>;

export function readThemeChoice(storage?: Pick<Storage, 'getItem'>): ThemeChoice {
  try {
    const wert = (storage ?? window.localStorage).getItem(THEME_KEY);
    return WAHLEN.find(wahl => wahl === wert) ?? 'light';
  } catch { return 'light'; }
}

export const resolveTheme = (choice: ThemeChoice, prefersDark: boolean): 'light' | 'dark' =>
  choice === 'system' ? (prefersDark ? 'dark' : 'light') : choice;

// Setzt die Klasse dark am Wurzelelement. Nur „System“ hört auf das Betriebssystem; die Rückgabe meldet das wieder ab.
export function applyThemeChoice(choice: ThemeChoice, root: Wurzel = document.documentElement,
  media: Medium | undefined = typeof window.matchMedia === 'function' ? window.matchMedia(SYSTEM_DUNKEL) : undefined): () => void {
  root.classList.toggle('dark', resolveTheme(choice, !!media?.matches) === 'dark');
  if (choice !== 'system' || !media) return () => {};
  const folgen = (event: { matches: boolean }) => { root.classList.toggle('dark', event.matches); };
  media.addEventListener('change', folgen);
  return () => media.removeEventListener('change', folgen);
}

// Meldet eine Wahl an main.tsx, das sie anwendet. Die Wahl reist im Ereignis mit, damit sie auch ohne Speicher gilt.
export function announceThemeChoice(choice: ThemeChoice): void {
  window.dispatchEvent(new CustomEvent<ThemeChoice>(THEME_EVENT, { detail: choice }));
}

// Speichert die Wahl für diesen Browser; ist der Speicher gesperrt, gilt sie bis zum Neuladen.
export function saveThemeChoice(choice: ThemeChoice): void {
  try { window.localStorage.setItem(THEME_KEY, choice); } catch { /* gilt dann bis zum Neuladen */ }
  announceThemeChoice(choice);
}

// F-09 (BAU-PRAEFERENZEN.md 1.2): Abgleich nach dem Laden des Profils. Hat das Konto eine Wahl, gilt sie hier (anwenden, falls sie
// vom Browser abweicht); hat es noch keine (null), wird die Wahl dieses Browsers einmal übernommen. Fehlt das Feld (undefined,
// Server ohne F-09), geschieht nichts.
export function farbschemaAbgleich(konto: ThemeChoice | null | undefined, browser: ThemeChoice): { anwenden?: ThemeChoice; uebernehmen?: ThemeChoice } {
  if (konto === undefined) return {};
  if (konto === null) return { uebernehmen: browser };
  return WAHLEN.includes(konto) && konto !== browser ? { anwenden: konto } : {};
}
